import ResetPasswordConfirmForm from './ResetPasswordConfirmForm'

export default ResetPasswordConfirmForm
